import styled from 'styled-components';

export const Header = styled.header`
  z-index: auto;
`;

export const UniversityLogo = styled.img`
  max-width: 250px;
  max-height: 60px;
`;

export const PartnerLogo = styled.img`
  max-width: 250px;
  max-height: 60px;
`;
